"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDashboards = void 0;
var sortItems = function (item) {
    item.elements.sort(function (a, b) {
        return a.order - b.order;
    });
    return item;
};
var sortDashboards = function (items) {
    return items.map(sortItems).sort(function (a, b) {
        if (a.position === b.position) {
            if (a.parent === 'CUSTOMER' && b.parent === 'PROJECT') {
                return -1;
            }
            else if (a.parent === 'PROJECT' && b.parent === 'CUSTOMER') {
                return 1;
            }
            return 0;
        }
        return a.position - b.position;
    });
};
exports.sortDashboards = sortDashboards;
